import axios from "axios";
import { GET_ACTS } from "./types";
import { endpoint } from "../config";

export const getActs = (limit = 100) => (dispatch, getState) => {
  let params = "?limit=" + limit;
  const token = getState().auth.token;
  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  axios
    .get(endpoint + "/acts/" + params, config)
    .then(res => {
      dispatch({
        type: GET_ACTS,
        payload: res.data
      });
    })
    .catch(err => console.log(err));
};
